import { ConversationUser } from "../../../api/api-hooks/comments/useFetchComments";
import ThumbnailWidget from "../../Widgets/ThumbnailWidget/ThumbnailWidget";

export default function AvatarAndName({ user }: { user: ConversationUser }) {
  if (!user) return null;

  return (
    <div className="tw:flex tw:items-center">
      <ThumbnailWidget record={user} imageKey={"ProfileImage"} mode="Avatar" />
      <h5 className="mb-0">{user?._RecordName}</h5>
    </div>
  );
}
